import {
  Button,
  Container,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@material-ui/core";
import Logo from "../../Assets/logo.jpeg";

import axios from "axios";
import { Link } from "react-router-dom";

import React, { Component } from "react";
import Constants from "../Variables/Constants";
import { getOrderNotificationToken } from "../../services/orderNotifications";

export default class Login extends Component {
  state = {
    error: false,
    mobile_no: "",
    password: "",
  };

  login = async (e) => {
    e.preventDefault();
    this.setState({
      loading: true,
    });

    let notificationToken = "";
    try {
      const notification = await getOrderNotificationToken({
        askPermission: true,
      });
      notificationToken = notification.token;
    } catch (error) {
      // A notification setup issue must not prevent an admin from logging in.
      console.warn("[ORDER_PUSH][LOGIN_TOKEN_FAILED]", error?.message);
    }

    let loginLoad = {
      mobile_no: this.state.mobile_no,
      password: this.state.password,
      notification_token: notificationToken,
    };

    axios
      .post(Constants.postUrls.login, loginLoad)
      .then((resp) => {
        localStorage.setItem("accessToken", resp.data.token);

        window.location.href = "/dashboard";

        this.setState({
          notification: true,
          loading: false,
        });
      })
      .catch((err) => {
        if (err) {
          console.log(err);
          this.setState({
            loading: false,
            message: "Invalid Credentials",
            error: true,
          });
          setTimeout(() => {
            this.setState({
              error: false,
            });
          }, 3000);
        }
      });
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  render() {
    return (
      <div className="loginWrapper">
        <div
          style={{
            height: "100vh",
            backgroundColor: "#111",
            opacity: "0.8",
          }}
        >
          <img
            src={Logo}
            style={{
              //  marginTop: "75px",
              marginLeft: "50px",
              height: "33%",
              width: "17%",
            }}
          />
          {/* https://files.slack.com/files-pri/TNF0B8YSZ-F02ASNY85PG/image.png */}
          <div>
            <Container maxWidth="md">
              <Grid container>
                <Grid
                  item
                  sm={6}
                  style={{
                    position: "relative",
                    height: "80vh",
                    marginTop: "-100px",
                  }}
                >
                  <Paper
                    className="loginCard"
                    elevation={15}
                    style={{ height: "58vh" }}
                  >
                    <Typography
                      variant="h4"
                      component="h2"
                      gutterBottom
                      style={{ color: "#1976d2" }}
                    >
                      The3DCreator
                    </Typography>
                    <Typography variant="h5" component="h1">
                      Log in
                    </Typography>
                    <Typography
                      variant="body2"
                      component="h1"
                      gutterBottom
                      color="textSecondary"
                    >
                      Continue to Admin dashboard
                    </Typography>
                    {/* <Typography
                  color="primary"
                  variant="body2"
                  style={{ alignSelf: "flex-end" , cursor:"pointer" }}
                >
                  Forgot password?
                </Typography> */}
                    <form className="loginFormWrapper" onSubmit={this.login}>
                      <TextField
                        id="Outlined Success"
                        color="success"
                        label="Registered Mobile Number"
                        variant="outlined"
                        fullWidth
                        name="mobile_no"
                        onChange={this.handleInput}
                      />
                      <TextField
                        id="outlined-basic"
                        label="Password"
                        variant="outlined"
                        fullWidth
                        name="password"
                        type="password"
                        onChange={this.handleInput}
                      />

                      <Button
                        style={{
                          alignSelf: "flex-start",
                          backgroundColor: "#1976d2",
                          color: "#fff",
                        }}
                        variant="contained"
                        size="large"
                        type="submit"
                      >
                        {this.state.loading ? (
                          "Logging In..."
                        ) : this.state.error ? (
                          <span style={{ color: "#BD0600" }}>
                            Incorrect Credentials!!!
                          </span>
                        ) : (
                          " Log In"
                        )}
                      </Button>
                    </form>

                    <Grid item sm={12} style={{ position: "relative" }}>
                      {/* <Link to="/forgot" style={{ textDecoration: "none" }}>
                        <Typography
                          variant="body2"
                          style={{
                            color: "#fff",
                            alignSelf: "right",
                            cursor: "pointer",
                            display: "inline",
                          }}
                        >
                          Forgot password?
                        </Typography>
                      </Link> */}
                      {/* <Link to="/change" style={{ textDecoration: "none" }}>
                    <Typography
                      color="primary"
                      variant="body2"
                      style={{
                        alignSelf: "flex-end",
                        cursor: "pointer",
                        display: "inline",
                        marginLeft: "10px",
                      }}
                    >
                      Change password?
                    </Typography>
                  </Link> */}
                    </Grid>
                  </Paper>
                </Grid>
              </Grid>
            </Container>
          </div>
        </div>
      </div>
    );
  }
}
